import moment from "moment-timezone";
import * as Ajax from '../ajax/Ajax';
import "../models/information/InformationResultModel";
/**
 * 一覧を取得します。
 *
 * @param fn ファンクション
 */

export function Query(searchWord, startRow, pageSize, fn) {
  Ajax.Post("InformationApi/Query", {
    searchWord: searchWord,
    startRow: startRow,
    pageSize: pageSize
  }, Ajax.ModelResult(fn));
}
/**
 * 一覧を取得します。
 *
 * @param fn ファンクション
 */

export function QueryView(searchWord, startRow, pageSize, fn) {
  Ajax.Post("InformationApi/QueryView", {
    searchWord: searchWord,
    startRow: startRow,
    pageSize: pageSize
  }, Ajax.ModelResult(fn));
}
/**
 * お知らせを追加します。
 *
 * @param title タイトル
 * @param contents 内容
 * @param startDateTime 公開開始日
 * @param endDateTime 公開終了日
 * @param organizationId 組織ID
 * @param fn ファンクション
 */

export function AddInformation(title, contents, startDateTime, endDateTime, organizationId, fn) {
  Ajax.Post("InformationApi/AddInformation", {
    title: title,
    contents: contents,
    startDateTime: moment(startDateTime).format("YYYY-MM-DDTHH:mm:ss"),
    endDateTime: moment(endDateTime).format("YYYY-MM-DDTHH:mm:ss"),
    organizationId: organizationId
  }, Ajax.ModelResult(fn));
}
/**
 * お知らせを更新します。
 *
 * @param id お知らせID
 * @param title タイトル
 * @param contents 内容
 * @param startDateTime 公開開始日
 * @param endDateTime 公開終了日
 * @param organizationId 組織ID
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ModifyInformation(id, title, contents, startDateTime, endDateTime, organizationId, updateDateTime, fn) {
  Ajax.Post("InformationApi/ModifyInformation", {
    id: id,
    title: title,
    contents: contents,
    startDateTime: moment(startDateTime).format("YYYY-MM-DDTHH:mm:ss"),
    endDateTime: moment(endDateTime).format("YYYY-MM-DDTHH:mm:ss"),
    organizationId: organizationId,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * お知らせを削除します。
 *
 * @param id お知らせID
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function DeleteInformation(id, updateDateTime, fn) {
  Ajax.Post("InformationApi/DeleteInformation", {
    id: id,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}
/**
 * お知らせを既読にします。
 *
 * @param id お知らせID
 * @param updateDateTime 更新日時
 * @param fn ファンクション
 */

export function ReadedInformation(id, updateDateTime, fn) {
  Ajax.Post("InformationApi/ReadedInformation", {
    id: id,
    updateDateTime: updateDateTime
  }, Ajax.ModelResult(fn));
}